(() => {
  // Option « Zéro déchet » du cart drawer.
  // Le footer du drawer est re-rendu via innerHTML à chaque mutation du panier :
  // aucun listener ne doit vivre sur la checkbox elle-même (il serait perdu, et
  // un <script> inline re-rendu ne s'exécute jamais). On délègue donc l'écoute
  // au document et on resynchronise l'état coché depuis cart.attributes.
  const SELECTOR = '[data-zero-waste-toggle]';
  const ATTRIBUTE = 'Zéro déchet';
  const CHECKED_VALUE = 'Oui';

  let updateInFlight = false;

  const getErrorsElement = () => document.getElementById('CartDrawer-CartErrors')
    || document.getElementById('cart-errors');

  const showCartError = () => {
    const errors = getErrorsElement();
    if (!errors) return;
    errors.textContent = (window.cartStrings && window.cartStrings.error)
      || 'Une erreur est survenue lors de la mise à jour de votre panier.';
  };

  const clearCartError = () => {
    const errors = getErrorsElement();
    if (errors && errors.textContent) errors.textContent = '';
  };

  // Réaligne la checkbox affichée sur l'état serveur (cart.attributes).
  const syncCheckbox = (attributes) => {
    const checkbox = document.querySelector(SELECTOR);
    if (!checkbox || !attributes) return;
    const shouldBeChecked = attributes[ATTRIBUTE] === CHECKED_VALUE;
    if (checkbox.checked !== shouldBeChecked) checkbox.checked = shouldBeChecked;
  };

  document.addEventListener('change', (event) => {
    const checkbox = event.target;
    if (!checkbox || typeof checkbox.matches !== 'function' || !checkbox.matches(SELECTOR)) return;

    const wantChecked = checkbox.checked;
    const attributes = {};
    attributes[ATTRIBUTE] = wantChecked ? CHECKED_VALUE : '';

    updateInFlight = true;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes })
    })
      .then((response) => {
        if (!response.ok) throw new Error('/cart/update.js HTTP ' + response.status);
        return response.json();
      })
      .then((cart) => {
        clearCartError();
        // La checkbox a pu être remplacée par un re-render pendant la requête :
        // on réaffirme l'état réellement enregistré côté serveur.
        syncCheckbox(cart && cart.attributes ? cart.attributes : attributes);
      })
      .catch(() => {
        // Échec : on rétablit l'état précédent (le serveur n'a rien enregistré)
        // et on affiche le message d'erreur natif du drawer.
        const current = document.querySelector(SELECTOR);
        if (current) current.checked = !wantChecked;
        showCartError();
      })
      .finally(() => {
        updateInFlight = false;
      });
  });

  // Les changements de quantité publient cartUpdate avec le JSON complet du
  // panier (assets/cart.js) : on en profite pour resynchroniser la checkbox
  // re-rendue. Les autres chemins de re-render (ajout produit, onCartUpdate)
  // rendent le `checked` côté serveur, donc rien à faire pour eux.
  const bindCartUpdateSync = () => {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined' || !PUB_SUB_EVENTS.cartUpdate) {
      return false;
    }
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (updateInFlight) return;
      const cartData = event && event.cartData;
      if (cartData && cartData.attributes) syncCheckbox(cartData.attributes);
    });
    return true;
  };

  if (!bindCartUpdateSync()) {
    document.addEventListener('DOMContentLoaded', bindCartUpdateSync);
  }
})();
